<template>
  <div class="header-wrapper">
    <div class="page-content">
      <div class="header">
        <span class="code-text" @mouseover="showQrcode" @mouseleave="hideQrcode">
          <i class="icon-erweima"/>扫码下载会生意App
          <div class="qrcode" v-show="showCode">
            <img :src="qrcode" />
          </div>
        </span>
        <!-- <span class="notice" @click="toKefu"><i class="icon-zaixiankefu" style="font-size: 18px;"/>在线客服</span> -->
        <span class="notice" @click="toNotice"><i class="el-icon-bell" style="font-size:15px;font-weight: bold;"/>消息</span>
        <div v-if="visible && msgNum" class="notice-box">
          <p>
            <span @click="toNotice"><span>{{ msgNum }}</span>条新消息</span>
            <i class="icon-del" style="margin-left: 10px;" @click="visible = false"></i>
          </p>
        </div>
        <span class="welcome">欢迎您，{{ pUid }}！</span>
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="user">
            {{ pName }}<i class="icon-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="out">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <img class="logo" :src="logo" @click="toShopping"/>

      <ul class="menu">
        <li>
          <router-link to="/shopping">订货中心</router-link>
        </li>
        <li>
          <router-link to="/weekReport">业绩分析</router-link>
        </li>
        <li>
          <router-link to="/mine">我的服务</router-link>
        </li>
        <li style="margin-right: 0;">
          <router-link to="/shoppingCart" class="cart-layout">
            <span class="icon-gouwuche"/>
            <el-badge class="badge" v-if="cartNum" :value="cartNum" :max="99"/>
            <span class="price" >￥{{ $util.formatThousand(totalPrice) }}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ShopAPI } from 'api/shop'
let shopAPI=new ShopAPI()
import localStore from 'util/localStore'
import { countLogUnreads } from 'api/notice'
import { mapMutations } from 'vuex'
import { mapActions } from 'vuex'
import { MyUtil } from '../util/MyUtil'

export default {
  data() {
    return {
      cartNum: 0, // 购物车数字
      product: [],
      promotion: [],
      pTotalPrice: 0, // 促销产品总金额（包含换购品）
      pTotalPriceExclude: 0, // 促销产品总金额（不包含换购品）
      productTotalPrice: 0, // 常规产品总金额
      fullGiftPrice: 0, // 满单促销换购品总金额
      totalPrice: 0, // 合计金额
      totalPriceExclude: 0, // 合计金额（不包含换购品）
      ifNotTime: null, // 当前如果是下单时间

      qrcode: require('../assets/images/qrcode.png'),
      showCode: false,
      logo: require('../assets/images/logo1.png'),
      pName: localStore.get('TUP_pInfo').pName,
      pOrganName2: localStore.get('TUP_pInfo').pOrganName2,
      pUid: localStore.get('TUP_pUid'),
      visible: true
    }
  },

  watch: {
    $route(to, from) {
      this.visible = true
    },

    '$store.state.cartFlag'(val) {
      //MyUtil.e('store.state.cartFlag:::', val)
      this.updateCartNum()
      this.updateTotalPrice()
    }
  },

  computed: {
    msgNum() {
      if (this.$store.state.msgNum > 99) {
        return '99+'
      } else {
        return this.$store.state.msgNum
      }
    }
  },

  methods: {
    // 更新购物车图标的数字
    updateCartNum() {
      //MyUtil.e("header updateCartNum")
      this.getCartNumber({
        numCallBack:(num)=>{
          this.cartNum = num
        }
      })
    },

    /**计算合计金额*/
    updateTotalPrice() {
      //MyUtil.e('header updateTotalPrice')
      let localCart=MyUtil.getLocalCart()
      this.product = localCart.product
      this.promotion = localCart.promotion
      if (!this.product.length && !this.promotion.length) {
        this.totalPrice = 0
        return
      }

      if (this.ifNotTime == null) {
        shopAPI.checkOrderPlan({
          bookType: localStore.get('TUP_pFirstorderDate') ? 0 : 1, // 0普订1首订
          timeType: 0 // 0草稿1下单
        }).then(res => {
          if (res.model) { // 请求结果为处于
            this.ifNotTime = false
            this.checkPromotions()
          } else {
            this.ifNotTime = true
          }
        })
      } else if (this.ifNotTime == false) {
        this.checkPromotions()
      }
    },

    // 检查促销
    checkPromotions() {
      let arr = this.promotion.map(item => {
        return {
          id: item.id,
          version: item.version,
          promotionId: item.promotionId
        }
      })
      if (!arr.length) {
        this.checkProductDownAndLack()
        return
      }
      shopAPI.checkPromotions(arr).then(res => {
        // 如果有被删除的促销
        res.model.deletes && res.model.deletes.forEach(item => {
          this.promotion = this.promotion.filter(i => {
            return item.id !== i.id
          })
        })
          
        // 如果有被修改的促销
        res.model.updates && res.model.updates.forEach(item => {
          for (let i = 0; i < this.promotion.length; i++) {
            if (item.id === this.promotion[i].id) {
              item.promotionRuleVO.productList && item.promotionRuleVO.productList.map(pItem => {
                if (pItem.isHave) {
                  pItem.selected = true
                }
                if (pItem.mustQty && item.type !== 4) {
                  pItem.selected = true
                  pItem.shopCartNum = pItem.mustQty
                }
                if (item.type === 4) {
                  pItem.selected = true
                  pItem.shopCartNum = pItem.productNum
                }
                return pItem
              })
              item.selected = true
              item.shopCartNum = 1
              item.ifEdit = false
              item.keyProductPrice = 0
              item.promotionTotalPrice = 0
              this.promotion[i] = item
            }
          }
        })
          
        this.checkProductDownAndLack()
      })
    },

    // 检查产品上下架及缺货情况
    checkProductDownAndLack() {
      //MyUtil.e('header checkProductDownAndLack start')
      let down = []
      let lack = []
      down = this.product.filter(i => {return i.pStatus === 2}).map(i => {return i.pCode})//下架
      lack = this.product.filter(i => {return !i.isHave}).map(i => {return i.pCode})      //缺货
      this.promotion.forEach((item) => {
        item.promotionRuleVO.productList && item.promotionRuleVO.productList.forEach((sItem) => {
          if (sItem.pStatus === 2 && down.indexOf(sItem.pCode) < 0) {
            down.push(sItem.pCode)
          }
          if (!sItem.isHave && lack.indexOf(sItem.pCode) < 0) {
            lack.push(sItem.pCode)
          }
        })
        if (item.type !== 0) { // 优惠促销没有rules
          item.promotionRuleVO.rules && item.promotionRuleVO.rules.forEach(sItem => {
            sItem.giftList && sItem.giftList.forEach(xsItem => {
              if (xsItem.pStatus === 2 && down.indexOf(xsItem.pCode) < 0) {
                down.push(xsItem.pCode)
              }
              if (!xsItem.isHave && lack.indexOf(xsItem.pCode) < 0) {
                lack.push(xsItem.pCode)
              }
            })
          })
        }
      })
      if (lack.length || down.length) {
        shopAPI.checkProductDownAndLack({
          inStockProductCode: lack,
          upProductCode: down
        }).then(res => {
          let data = res.model
          if (data.inStockProductCode.length) {
            this.product = this.product.map(item => {
              if (data.inStockProductCode.indexOf(item.pCode) >= 0) {
                item.isHave = 1
              }
              return item
            })
            this.promotion = this.promotion.map(item => {
              item.promotionRuleVO.productList = item.promotionRuleVO.productList.map(sItem => {
                if (data.inStockProductCode.indexOf(sItem.pCode) >= 0) {
                  sItem.isHave = 1
                }
                return sItem
              })
              if (item.type !== 0) {
                item.promotionRuleVO.rules = item.promotionRuleVO.rules.map(sItem => {
                  sItem.giftList = (sItem.giftList || []).map(xsItem => {
                    if (data.inStockProductCode.indexOf(xsItem.pCode) >= 0) {
                      xsItem.isHave = 1
                    }
                    return xsItem
                  })
                  return sItem
                })
              }
              return item
            })
          }
          if (data.upProductCode.length) {
            this.product = this.product.map(item => {
              if (data.upProductCode.indexOf(item.pCode) >= 0) {
                item.pStatus = 1
              }
              return item
            })
            this.promotion = this.promotion.map(item => {
              item.promotionRuleVO.productList = item.promotionRuleVO.productList.map(sItem => {
                if (data.upProductCode.indexOf(sItem.pCode) >= 0) {
                  sItem.pStatus = 1
                }
                return sItem
              })
              if (item.type !== 0) {
                item.promotionRuleVO.rules = item.promotionRuleVO.rules.map(sItem => {
                  sItem.giftList = (sItem.giftList || []).map(xsItem => {
                    if (data.upProductCode.indexOf(xsItem.pCode) >= 0) {
                      xsItem.pStatus = 1
                    }
                    return xsItem
                  })
                  return sItem
                })
              }
              return item
            })
          }
          this._initPromotion()
        })
      } else {
        this._initPromotion()
      }
      //MyUtil.e('header checkProductDownAndLack end')
    },

    _initPromotion() {
      if (this.product.length || this.promotion.length) {
        this.watchProduct()
        this.watchPromotion()
      }
    },

    /**处理常规产品*/
    watchProduct() {
      let productTotalPrice = 0
      for (let i = 0; i < this.product.length; i++) {
        let pItem=this.product[i]
        if (pItem.shopCartNum === 0) {
          this.product.splice(i, 1)
        }else if(pItem.selected) {
          productTotalPrice += pItem.orderRatioPrice * pItem.shopCartNum
        }
      }
      this.productTotalPrice = Math.round(productTotalPrice * 100) / 100
      this.watchTotalPriceExclude(3)
    },

    /**处理促销产品*/
    watchPromotion() {
      //MyUtil.e('header watchPromotion start')
      let pTotalPrice = 0 // 促销产品总金额
      let pTotalPriceExclude = 0 // 促销产品总金额（不包含换购品）
      this.ifNull = false

      for (let i = 0; i < this.promotion.length; i++) {
        let item = this.promotion[i]
        let productList = item.promotionRuleVO.productList
        let rules = item.promotionRuleVO.rules
        let relation = item.promotionRuleVO.relation // 0并列 1互斥
        let productTotalNum = 0 // 主产品总数量
        let productTotalSum = 0 // 主产品总价格

        if (item.type === 0) { // 优惠
          this.ifNull = true
          let promotionTotalPrice = 0 // 单个促销总金额（包含赠品）
          for (let j = 0; j < productList.length; j++) {
            if (productList[j].selected) {
              promotionTotalPrice += productList[j].shopCartNum * productList[j].orderRatioPrice
            }
          }
          item.promotionTotalPrice = promotionTotalPrice
          item.keyProductPrice = Math.round(promotionTotalPrice * 100) / 100 // 主产品总金额
          pTotalPriceExclude += item.keyProductPrice
          pTotalPrice += item.promotionTotalPrice
        }else if (item.type === 1) { // 买赠
          this.ifNull = true
          let promotionTotalPrice = 0 // 单个促销总金额（包含赠品）
          for (let k = 0; k < productList.length; k++) {
            if (productList[k].selected) {
              productTotalNum += productList[k].shopCartNum
              productTotalSum += productList[k].shopCartNum * productList[k].orderRatioPrice
              promotionTotalPrice += productList[k].shopCartNum * productList[k].orderRatioPrice
            }
          }
          item.keyProductPrice = Math.round(promotionTotalPrice * 100) / 100 // 主产品总金额
          for (let l = 0; l < rules.length; l++) {
            if (rules[l].byMoney) { // 购买满金额
              if (rules[l].sum <= productTotalSum && rules[l].min <= productTotalNum) { // 如果主产品总金额大于条件金额&&主产品总数量大于起订量
                if (rules[l].products.length) { // 如果有设置关联主产品
                  let relateSum = 0
                  let relateNum = 0
                  for (let m = 0; m < rules[l].products.length; m++) {
                    for (let n = 0; n < productList.length; n++) {
                      if (rules[l].products[m] === productList[n].pCode && productList[n].selected) {
                        relateSum += productList[n].shopCartNum * productList[n].orderRatioPrice
                        relateNum += productList[n].shopCartNum
                      }
                    }
                  }
                  if (rules[l].sum <= relateSum && rules[l].min <= relateNum) { // 如果符合条件
                    rules[l].active = true
                    rules[l].chose = relation === 0 && rules[l].chose === 0 ? 1 : rules[l].chose
                    for (let m = 0; m < rules[l].giftList.length; m++) {
                      let multi = Math.floor(relateSum / rules[l].sum)
                      let loop = rules[l].infinite || multi <= rules[l].loop ? multi : rules[l].loop // 如果翻倍次数不限或者可翻倍次数小于等于设置的倍数
                      let availableQtyBefore = rules[l].giftList[m].maxQuotaQty
                      if (rules[l].giftList[m].avaliableWithRatioQty !== null) {
                        rules[l].giftList[m].maxQuotaQty = Math.min(loop * rules[l].giftList[m].productNum, rules[l].giftList[m].avaliableWithRatioQty) // 最大可购买数
                      } else {
                        rules[l].giftList[m].maxQuotaQty = loop * rules[l].giftList[m].productNum
                      }
                      if (rules[l].giftList[m].orderRatioPrice) { // 如果为换购品
                        rules[l].giftList[m].shopCartNum = availableQtyBefore === rules[l].giftList[m].shopCartNum ? rules[l].giftList[m].maxQuotaQty : Math.min(rules[l].giftList[m].maxQuotaQty, rules[l].giftList[m].shopCartNum)
                      } else { // 如果为赠品
                        rules[l].giftList[m].shopCartNum = rules[l].giftList[m].maxQuotaQty
                      }
                      // rules[l].giftList[m].shopCartNum = rules[l].giftList[m].orderRatioPrice ? Math.min(rules[l].giftList[m].maxQuotaQty, rules[l].giftList[m].shopCartNum) : rules[l].giftList[m].maxQuotaQty
                      if (rules[l].chose === 1 && relation === 0) {
                        // 如果是换购品，在上架&有货情况才选中; 如果是赠品，直接选中
                        rules[l].giftList[m].selected = (rules[l].giftList[m].orderRatioPrice && rules[l].giftList[m].isHave && rules[l].giftList[m].pStatus !== 2) || !rules[l].giftList[m].orderRatioPrice
                      }
                    }
                  } else { // 如果不符合条件
                    rules[l].active = false
                    rules[l].chose = 0
                    for (let m = 0; m < rules[l].giftList.length; m++) {
                      rules[l].giftList[m].shopCartNum = 0
                      rules[l].giftList[m].maxQuotaQty = 0
                      rules[l].giftList[m].selected = false
                    }
                  }
                } else { // 如果没有设置关联主产品
                  rules[l].active = true // 符合条件，变成可激活状态
                  rules[l].chose = relation === 0 && rules[l].chose === 0 ? 1 : rules[l].chose // 如果是并列条件且用户没操作过，符合条件就默认勾选上
                  for (let m = 0; m < rules[l].giftList.length; m++) {
                    let multi = Math.floor(productTotalSum / rules[l].sum)
                    let loop = rules[l].infinite || multi <= rules[l].loop ? multi : rules[l].loop // 如果翻倍次数不限或者可翻倍次数小于等于设置的倍数
                    let availableQtyBefore = rules[l].giftList[m].maxQuotaQty // 保留原先的avaliableWithRatioQty，与后面做对比，如果有变化则是主产品数量发生修改，如果没变化则当作是换购品在做修改
                    if (rules[l].giftList[m].avaliableWithRatioQty !== null) {
                      rules[l].giftList[m].maxQuotaQty = Math.min(loop * rules[l].giftList[m].productNum, rules[l].giftList[m].avaliableWithRatioQty) // 最大可购买数
                    } else {
                      rules[l].giftList[m].maxQuotaQty = loop * rules[l].giftList[m].productNum
                    }
                    // 赠送品默认赠送最大值,换购品初始值为最大值（修改第三次了！！！）
                    if (rules[l].giftList[m].orderRatioPrice) { // 如果为换购品，用户未修改购物车数量，则取可换购最大值，用户修改过，则取min(修改过后的数值，可换购最大值)
                      rules[l].giftList[m].shopCartNum = availableQtyBefore === rules[l].giftList[m].shopCartNum ? rules[l].giftList[m].maxQuotaQty : Math.min(rules[l].giftList[m].maxQuotaQty, rules[l].giftList[m].shopCartNum)
                    } else { // 如果为赠品
                      rules[l].giftList[m].shopCartNum = rules[l].giftList[m].maxQuotaQty
                    }
                    // rules[l].giftList[m].shopCartNum = rules[l].giftList[m].orderRatioPrice ? Math.min(rules[l].giftList[m].maxQuotaQty, rules[l].giftList[m].shopCartNum) : rules[l].giftList[m].maxQuotaQty
                    if (rules[l].chose === 1 && relation === 0) {
                      // 如果是换购品，在上架&有货情况才选中; 如果是赠品，直接选中
                      rules[l].giftList[m].selected = (rules[l].giftList[m].orderRatioPrice && rules[l].giftList[m].isHave && rules[l].giftList[m].pStatus !== 2) || !rules[l].giftList[m].orderRatioPrice
                    }
                  }
                }
              } else { // 如果不符合赠品/换购促销优惠条件，数量重置为0，取消勾选
                rules[l].active = false
                rules[l].chose = 0
                for (let m = 0; m < rules[l].giftList.length; m++) {
                  rules[l].giftList[m].shopCartNum = 0
                  rules[l].giftList[m].maxQuotaQty = 0
                  rules[l].giftList[m].selected = false
                }
              }
            } else { // 购买满数量，v1.3.1添加需求：增加赠品/换购品跟随主产品的机制（这里只做针对购买满数量的需求
              if (rules[l].num <= productTotalNum && rules[l].min <= productTotalNum) { // 如果主产品总数量大于条件数量&&主产品总数量大于起订量
                if (rules[l].products.length) { // 如果有设置关联主产品
                  let relateNum = 0
                  for (let m = 0; m < rules[l].products.length; m++) {
                    for (let n = 0; n < productList.length; n++) {
                      if (rules[l].products[m] === productList[n].pCode && productList[n].selected) {
                        relateNum += productList[n].shopCartNum
                      }
                    }
                  }
                  if (rules[l].num <= relateNum && rules[l].min <= relateNum) { // 如果符合条件
                    rules[l].active = true
                    rules[l].chose = relation === 0 && rules[l].chose === 0 ? 1 : rules[l].chose
                    for (let m = 0; m < rules[l].giftList.length; m++) {
                      let multi = Math.floor(relateNum / rules[l].num)
                      let loop = rules[l].infinite || multi <= rules[l].loop ? multi : rules[l].loop // 如果翻倍次数不限或者可翻倍次数小于等于设置的倍数
                      let availableQtyBefore = rules[l].giftList[m].maxQuotaQty
                      if (rules[l].giftList[m].avaliableWithRatioQty !== null) {
                        rules[l].giftList[m].maxQuotaQty = Math.min(loop * rules[l].giftList[m].productNum, rules[l].giftList[m].avaliableWithRatioQty) // 最大可购买数
                      } else {
                        rules[l].giftList[m].maxQuotaQty = loop * rules[l].giftList[m].productNum
                      }
                      if (rules[l].giftList[m].orderRatioPrice) { // 如果为换购品
                        rules[l].giftList[m].shopCartNum = availableQtyBefore === rules[l].giftList[m].shopCartNum ? rules[l].giftList[m].maxQuotaQty : Math.min(rules[l].giftList[m].maxQuotaQty, rules[l].giftList[m].shopCartNum)
                      } else { // 如果为赠品
                        rules[l].giftList[m].shopCartNum = rules[l].giftList[m].maxQuotaQty
                      }
                      // rules[l].giftList[m].shopCartNum = rules[l].giftList[m].orderRatioPrice ? Math.min(rules[l].giftList[m].maxQuotaQty, rules[l].giftList[m].shopCartNum) : rules[l].giftList[m].maxQuotaQty
                      if (rules[l].chose === 1 && relation === 0) {
                        // 如果是换购品，在上架&有货情况才选中; 如果是赠品，直接选中
                        rules[l].giftList[m].selected = (rules[l].giftList[m].orderRatioPrice && rules[l].giftList[m].isHave && rules[l].giftList[m].pStatus !== 2) || !rules[l].giftList[m].orderRatioPrice
                      }
                    }
                  } else { // 如果不符合条件
                    rules[l].active = false
                    rules[l].chose = 0
                    for (let m = 0; m < rules[l].giftList.length; m++) {
                      rules[l].giftList[m].shopCartNum = 0
                      rules[l].giftList[m].maxQuotaQty = 0
                      rules[l].giftList[m].selected = false
                    }
                  }
                } else { // 如果没有设置关联主产品
                  rules[l].active = true
                  rules[l].chose = relation === 0 && rules[l].chose === 0 ? 1 : rules[l].chose
                  for (let m = 0; m < rules[l].giftList.length; m++) {
                    let multi = Math.floor(productTotalNum / rules[l].num)
                    let loop = rules[l].infinite || multi <= rules[l].loop ? multi : rules[l].loop // 如果翻倍次数不限或者可翻倍次数小于等于设置的倍数
                    let availableQtyBefore = rules[l].giftList[m].maxQuotaQty
                    if (rules[l].giftList[m].avaliableWithRatioQty !== null) {
                      rules[l].giftList[m].maxQuotaQty = Math.min(loop * rules[l].giftList[m].productNum, rules[l].giftList[m].avaliableWithRatioQty) // 最大可购买数
                    } else {
                      rules[l].giftList[m].maxQuotaQty = loop * rules[l].giftList[m].productNum
                    }
                    if (rules[l].giftList[m].orderRatioPrice) { // 如果为换购品
                      rules[l].giftList[m].shopCartNum = availableQtyBefore === rules[l].giftList[m].shopCartNum ? rules[l].giftList[m].maxQuotaQty : Math.min(rules[l].giftList[m].maxQuotaQty, rules[l].giftList[m].shopCartNum)
                    } else { // 如果为赠品
                      rules[l].giftList[m].shopCartNum = rules[l].giftList[m].maxQuotaQty
                    }
                    // rules[l].giftList[m].shopCartNum = rules[l].giftList[m].orderRatioPrice ? Math.min(rules[l].giftList[m].maxQuotaQty, rules[l].giftList[m].shopCartNum) : rules[l].giftList[m].maxQuotaQty
                    if (rules[l].chose === 1 && relation === 0) {
                      // 如果是换购品，在上架&有货情况才选中; 如果是赠品，直接选中
                      rules[l].giftList[m].selected = (rules[l].giftList[m].orderRatioPrice && rules[l].giftList[m].isHave && rules[l].giftList[m].pStatus !== 2) || !rules[l].giftList[m].orderRatioPrice
                    }
                  }
                }
              } else { // 如果不符合赠品/换购促销优惠条件，数量重置为0，取消勾选
                rules[l].active = false
                rules[l].chose = 0
                for (let m = 0; m < rules[l].giftList.length; m++) {
                  rules[l].giftList[m].shopCartNum = 0
                  rules[l].giftList[m].maxQuotaQty = 0
                  rules[l].giftList[m].selected = false
                }
              }
            }
          }
          if (relation === 1) { // 互斥
            // chose含义
            // 0 系统默认不选
            // 1 系统勾选
            // 2 用户手动取消勾选
            // 3 用户手动勾选
            let activeLen = rules.filter(i => { // 筛选是否有可选择的规则
              return i.active
            }).length
            if (activeLen) {
              let choseLen = rules.filter(i => { // 筛选是否有用户操作赠送/换购品的促销
                return i.chose === 2 || i.chose === 3
              }).length
              if (choseLen === 0) { // 如果用户没有操作，则都是系统选择的，对此做最优方案选择
                let byMoneyNum = rules.filter(i => { // 计算配置为满金额的规则的条数
                  return i.byMoney
                }).length
                let maxIndex = 0
                if (byMoneyNum === 0) { // 如果规则都为满数量，选择符合条件中条件数量最多的
                  rules.forEach((item, index, arr) => {
                    if (item.active) {
                      maxIndex = item.num > arr[maxIndex].num ? index : maxIndex
                    }
                  })
                } else if (byMoneyNum === rules.length) { // 如果规则都为满金额，选择符合条件中金额最多的
                  rules.forEach((item, index, arr) => {
                    if (item.active) {
                      maxIndex = item.sum > arr[maxIndex].sum ? index : maxIndex
                    }
                  })
                } else { // 如果不统一，取第一条符合条件的
                  for (let i = 0; i < rules.length; i++) {
                    if (rules[i].active) {
                      maxIndex = i
                      break
                    }
                  }
                }
                for (let l = 0; l < rules.length; l++) {
                  if (l === maxIndex) {
                    rules[l].chose = 1
                    rules[l].giftList = rules[l].giftList.map(x => {
                      x.selected = (x.orderRatioPrice && x.isHave && x.pStatus !== 2) || !x.orderRatioPrice
                      return x
                    })
                  } else {
                    rules[l].chose = 0
                    rules[l].giftList = rules[l].giftList.map(x => {
                      x.selected = false
                      return x
                    })
                  }
                }
              } else { // 如果用户操作过
              }
            }
          }

          rules.forEach((value) => {
            if (value.chose === 1 || value.chose === 3) {
              value.giftList.forEach(val => {
                if (val.selected && val.orderRatioPrice) {
                  promotionTotalPrice += val.shopCartNum * val.orderRatioPrice
                }
              })
            }
          })
          item.promotionTotalPrice = promotionTotalPrice
          pTotalPriceExclude += item.keyProductPrice
          pTotalPrice += item.promotionTotalPrice

          //MyUtil.e(pTotalPrice, '买赠')
        }else if (item.type === 4) { // 首订礼包
          this.ifNull = true
          let promotionTotalPrice = 0 // 单个促销总金额（包含赠品）
          for (let k = 0; k < productList.length; k++) {
            if (productList[k].selected) {
              promotionTotalPrice += productList[k].shopCartNum * productList[k].orderRatioPrice
            }
          }
          for (let l = 0; l < rules.length; l++) {
            if (item.selected) {
              rules[l].active = true
              rules[l].chose = 1
              for (let m = 0; m < rules[l].giftList.length; m++) {
                let availableQtyBefore = rules[l].giftList[m].maxQuotaQty
                rules[l].giftList[m].maxQuotaQty = rules[l].giftList[m].avaliableWithRatioQty !== null ? Math.min(rules[l].giftList[m].avaliableWithRatioQty, rules[l].giftList[m].productNum) : rules[l].giftList[m].productNum
                // rules[l].giftList[m].shopCartNum = rules[l].giftList[m].maxQuotaQty
                if (rules[l].giftList[m].orderRatioPrice) { // 如果为换购品
                  rules[l].giftList[m].shopCartNum = availableQtyBefore === rules[l].giftList[m].shopCartNum ? rules[l].giftList[m].maxQuotaQty : Math.min(rules[l].giftList[m].maxQuotaQty, rules[l].giftList[m].shopCartNum)
                } else { // 如果为赠品
                  rules[l].giftList[m].shopCartNum = rules[l].giftList[m].maxQuotaQty
                }
                if (rules[l].chose === 1) {
                  // 如果是换购品，在上架&有货情况才选中; 如果是赠品，直接选中
                  rules[l].giftList[m].selected = (rules[l].giftList[m].orderRatioPrice && rules[l].giftList[m].isHave && rules[l].giftList[m].pStatus !== 2) || !rules[l].giftList[m].orderRatioPrice
                }
              }
            } else {
              rules[l].active = false
              rules[l].chose = 0
              for (let m = 0; m < rules[l].giftList.length; m++) {
                rules[l].giftList[m].shopCartNum = 0
                rules[l].giftList[m].maxQuotaQty = 0
                rules[l].giftList[m].selected = false
              }
            }
          }
          rules.forEach((value) => {
            if (value.chose === 1 || value.chose === 3) {
              value.giftList.forEach(val => {
                if (val.selected && val.orderRatioPrice) {
                  promotionTotalPrice += val.shopCartNum * val.orderRatioPrice
                }
              })
            }
          })
          item.keyProductPrice = Math.round(promotionTotalPrice * 100) / 100 // 主产品总金额
          item.promotionTotalPrice = promotionTotalPrice
          pTotalPriceExclude += item.keyProductPrice
          pTotalPrice += item.promotionTotalPrice
        }else if(item.type === 5){
          //MyUtil.e("-------------header watchPromotion 组合促销-----------------")
          item.productNum=0
          item.allMoney=0
          rules=rules.map(rItem => {
            rItem.productNum = 0
            rItem.setMealProductList=rItem.setMealProductList.map(pItem => {
              rItem.productNum += pItem.productNum
              return pItem
            })
            item.productNum+=rItem.productNum 
            return rItem
          })

          if(item.promotionRuleVO.setMealPriceType==1){//分组合计
            rules.forEach(rItem => {
              item.allMoney+=(rItem.productNum*rItem.setMealGroupPrice) //分组数量*单款价格
            })
          }else if(item.promotionRuleVO.setMealPriceType==0){//固定价格
            item.allMoney=item.promotionRuleVO.setMealPriceAmout
          }
          //MyUtil.e("=======>>>",item.allMoney,item.shopCartNum)
          item.allMoney=item.allMoney*item.shopCartNum
          if(item.selected ){
            pTotalPriceExclude += item.allMoney
            pTotalPrice += item.allMoney
          }
        }
        this.promotion[i] = item
      }

      this.pTotalPrice = pTotalPrice
      this.pTotalPriceExclude = pTotalPriceExclude
      this.watchTotalPriceExclude(1)
      //MyUtil.e(pTotalPrice, 'watchPromotion end')
    },

    // 主产品总金额决定满单促销是否生效
    watchTotalPriceExclude(type) {
      this.totalPriceExclude = Math.round((this.pTotalPriceExclude + this.productTotalPrice) * 100) / 100
      let fullGiftPrice = 0 // 满单换购品总金额
      for (let i = 0; i < this.promotion.length; i++) {
        if (this.promotion[i].type === 3) { // 满单促销
          let promotionRuleVO = this.promotion[i].promotionRuleVO
          let rules = promotionRuleVO.rules
          let promotionTotalPrice = 0 // 单个促销总金额（包含赠品）

          for (let j = 0; j < rules.length; j++) {
            if (rules[j].sum <= this.totalPriceExclude) { // 如果规则主产品总金额大于等于生效金额
              rules[j].active = true // 符合条件，变成可激活状态
              rules[j].chose = promotionRuleVO.relation === 0 && rules[j].chose === 0 ? 1 : rules[j].chose // 如果是并列条件且用户没操作过，符合条件就默认勾选上
              for (let m = 0; m < rules[j].giftList.length; m++) {
                let multi = Math.floor(this.totalPriceExclude / rules[j].sum)
                let loop = rules[j].infinite || multi <= rules[j].loop ? multi : rules[j].loop // 如果翻倍次数不限或者可翻倍次数小于等于设置的倍数
                let availableQtyBefore = rules[j].giftList[m].maxQuotaQty // 保留原先的avaliableWithRatioQty，与后面做对比，如果有变化则是主产品数量发生修改，如果没变化则当作是赠品在做修改
                if (rules[j].giftList[m].avaliableWithRatioQty !== null) {
                  rules[j].giftList[m].maxQuotaQty = Math.min(loop * rules[j].giftList[m].productNum, rules[j].giftList[m].avaliableWithRatioQty) // 最大可购买数
                } else {
                  rules[j].giftList[m].maxQuotaQty = loop * rules[j].giftList[m].productNum
                }
                if (rules[j].giftList[m].orderRatioPrice) { // 如果为换购品
                  rules[j].giftList[m].shopCartNum = availableQtyBefore === rules[j].giftList[m].shopCartNum ? rules[j].giftList[m].maxQuotaQty : Math.min(rules[j].giftList[m].maxQuotaQty, rules[j].giftList[m].shopCartNum)
                } else { // 如果为赠品
                  rules[j].giftList[m].shopCartNum = rules[j].giftList[m].maxQuotaQty
                }
                // rules[j].giftList[m].shopCartNum = rules[j].giftList[m].orderRatioPrice ? Math.min(rules[j].giftList[m].maxQuotaQty, rules[j].giftList[m].shopCartNum) : rules[j].giftList[m].maxQuotaQty
                if (promotionRuleVO.relation === 0 && rules[j].chose === 1) {
                  // 如果是换购品，在上架&有货情况才选中; 如果是赠品，直接选中
                  rules[j].giftList[m].selected = (rules[j].giftList[m].orderRatioPrice && rules[j].giftList[m].isHave && rules[j].giftList[m].pStatus !== 2) || !rules[j].giftList[m].orderRatioPrice
                }
              }
            } else { // 如果不符合赠品/换购促销优惠条件，数量重置为0，取消勾选
              rules[j].active = false
              rules[j].chose = 0
              for (let m = 0; m < rules[j].giftList.length; m++) {
                rules[j].giftList[m].shopCartNum = 0
                rules[j].giftList[m].maxQuotaQty = 0
                rules[j].giftList[m].selected = false
              }
            }
          }

          let activeLen = rules.filter(i => { // 筛选是否有可选择的规则
            return i.active
          }).length
          this.promotion[i].isMust = activeLen ? 1 : 0 // 借isMust这个字段存储满单规则是否有生效，如果全不生效，则隐藏
          if (activeLen && promotionRuleVO.relation === 1) { // 互斥
            // chose含义
            // 0 系统默认不选
            // 1 系统勾选
            // 2 用户手动取消勾选
            // 3 用户手动勾选
            let choseLen = rules.filter(i => { // 筛选是否有用户操作赠送/换购品的促销
              return i.chose === 2 || i.chose === 3
            }).length
            if (choseLen === 0) { // 如果用户没有操作，则都是系统选择的，对此做最优方案选择
              let maxIndex = 0
              rules.forEach((item, index, arr) => {
                if (item.active) {
                  maxIndex = item.sum > arr[maxIndex].sum ? index : maxIndex
                }
              })
              for (let l = 0; l < rules.length; l++) {
                if (l === maxIndex) {
                  rules[l].chose = 1
                  rules[l].giftList = rules[l].giftList.map(x => {
                    x.selected = (x.orderRatioPrice && x.isHave && x.pStatus !== 2) || !x.orderRatioPrice
                    return x
                  })
                } else {
                  rules[l].chose = 0
                  rules[l].giftList = rules[l].giftList.map(x => {
                    x.selected = false
                    return x
                  })
                }
              }
            }
          }

          rules.forEach((value) => {
            if (value.chose === 1 || value.chose === 3) {
              value.giftList.forEach(val => {
                if (val.selected && val.orderRatioPrice) {
                  promotionTotalPrice += val.shopCartNum * val.orderRatioPrice
                }
              })
            }
          })
          this.promotion[i].promotionTotalPrice = promotionTotalPrice
          fullGiftPrice += this.promotion[i].promotionTotalPrice
        }
      }

      this.fullGiftPrice = fullGiftPrice
      this.totalPrice = Math.round((this.pTotalPrice + this.productTotalPrice + this.fullGiftPrice) * 100) / 100

    },

    _getUnread() {
      countLogUnreads().then(rs => {
        this.setMsgNum(rs.model)
      })
    },
    showQrcode() {
      this.showCode = true
    },
    hideQrcode() {
      this.showCode = false
    },
    toKefu() {
      //window.open(encodeURI('https://chat10.live800.com/live800/chatClient/chatbox.jsp?companyID=192985&configID=169608&jid=4847835560&info=&userId=' + this.pUid + '&name=[' + this.pUid + ']' + this.pName + '&memo=' + this.pOrganName2))

      var liveURL = encodeURIComponent('userId=' + this.pUid + '&name=[' + this.pUid + ']' + this.pName + '&memo=' + this.pOrganName2);
      window.open('https://chat10.live800.com/live800/chatClient/chatbox.jsp?companyID=192985&configID=169608&jid=4847835560&info=' + liveURL + '&s=1');
    },
    toNotice() {
      this.$router.push({
        path: '/notice'
      })
    },
    handleCommand(command) {
      switch (command) {
        // case "password":
        //   this.$router.push({
        //     path: '/frame/password'
        //   })
        // break
        case 'out':
          localStore.clear()
          this.$router.push({
            path: '/login'
          })
          // this.$storage.clearAll()
          break
      }
    },
    toShopping() {
      this.$router.push({
        path: '/'
      })
    },
    ...mapMutations({
      setMsgNum: 'SET_MSGNUM'
    }),
    //映射store中的异步操作的 actions,这里是关联util/cart的方法
    ...mapActions([
      'getCartNumber'
    ])
  },

  created() {
    this.$store.state.cartFlag += 1
    this._getUnread()
  },
}
</script>

<style lang="scss">
@import "~assets/style/variable";

.header-wrapper {
  border-bottom: 1px solid $border;

  .page-content {
    width: var(--contentWidth);
    height: 120px;
    margin: 0 auto;
    position: relative;

    .header {
      float: right;
      margin-top: 14px;
      position: relative;

      .welcome {
        border-right: 1px solid $color-text;
        padding-right: 8px;
      }

      .user {
        margin-left: 8px;
        color: $color-text;

        i {
          margin-left: 3px;
        }
      }

      .code-text {
        cursor: pointer;
        margin-right: 30px;
        color: $color-theme;
        position: relative;
        margin-top: -3px;

        .icon-erweima {
          font-size: 30px;
          position: absolute;
          top: -5px;
          left: -28px;
        }

        .qrcode {
          position: absolute;
          border: 1px solid #e0eaee;
          background-color: $color-white;
          top: 30px;
          left: -40px;
          z-index: 100;
          padding: 13px;
          border-radius: 7px;
        }
      }
      .notice {
        cursor: pointer;
        padding-right: 30px;
        color: $color-theme;
        i {
          margin-right: 4px;
        }
      }

      .notice-box {
        position: absolute;
        left: 210px;
        box-shadow: 0px 2px 4px 0px #e3e7ea;
        border: solid 1px #e5e5e5;
        padding: 5px 8px;
        border-radius: 5px;
        top: 22px;
        cursor: pointer;

        span>span {
          color: $color-theme;
          font-weight: bold;
          margin-right: 3px;
        }

        i {
          color: #6d787c;
        }

        .triangle {
          position: absolute;
          top: -10px;
          left: 50px;
          width: 0;
          height: 0;
          border-width: 0 10px 10px;
          border-style: solid;
          border-color: transparent transparent #e5e5e5;

          &:after {
            content: "";
            position: absolute;
            top: 0px;
            left: -7px;
            border-width: 0 8px 8px;
            border-style: solid;
            border-color: transparent transparent #fff;
          }
        }
      }
      .notice-box:after {
        content: "";
        position: absolute;
        top: -6px;
        right: 33px;
        width: 12px; /* 尖角的大小 */
        height: 6px; /* 尖角的大小 */
        background-color: #e5e5e5; /* 与背景相同 */
        clip-path: polygon(50% 0, 100% 100%, 0 100%); /* 创建尖角 */
        pointer-events: none; /* 确保边框不影响元素的点击事件 */
      }
    }

    .logo {
      margin-top: 25px;
      cursor: pointer;
    }

    .menu {
      height: 65px;
      line-height: 65px;
      position: absolute;
      right: 1px;
      bottom: 0;

      li {
        display: inline-block;
        margin-right: 60px;
        font-size: var(--sizeX);

        p {
          color: #ccc
        }

        .router-link-active {
          color: $color-theme;
          font-weight: bolder;
          position: relative;

          &::after {
            content: '';
            position: absolute;
            bottom: -25px;
            left: 50%;
            transform: translateX(-50%);
            width: 40px;
            height: 4px;
            background-color: $color-theme;
          }
        }

        .cart-layout{
          position: relative;
          overflow:visible;

          .icon-gouwuche {
            position: relative;
            top: 5px;
            font-size: 28px;
            color: $color-theme;
            margin-right: 5px;
          }
          .badge{
            position: absolute;
            left: 10px;
            top:-10px;
            height: 20px !important;
            line-height: 20px !important;
          }
          .price{
            position: relative;
            top: 3px;
            color: #BC4742; 
            font-size: 1.2em;
          }
        }
      }

      .menu-a {
        position: relative;
        // right: 0px;
        top: 5px;
        width: 28px;
        height: 28px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/header.vue